import ndjsonStream from 'can-ndjson-stream';
import type { NDJsonError } from 'can-ndjson-stream';

import fetch from './fetch';

export async function getNdJsonStream<T>(url: string) {
  const response = await fetch(url, { headers: { Accept: 'application/x-ndjson' } });
  if (response.headers.get('Content-Type') !== 'application/x-ndjson') {
    throw new Error(`Unexpected content type: ${response.headers.get('Content-Type')}`);
  }

  return ndjsonStream<T>(response.body);
}

export function ndJsonChunkIsError(chunk: any): chunk is NDJsonError {
  return !!(chunk as NDJsonError).error;
}
